import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import { drawerWidth, openedMixin, closedMixin } from '../lib';

export const DrawerStyled = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  '& .MuiDrawer-paper': {
    borderRight: 'none',
    backgroundColor: theme.palette.mode === 'dark' ? '#141414' : '#1A1A1A',
  },
  variants: [
    {
      props: ({ open }: { open?: boolean }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': { ...openedMixin(theme) },
      },
    },
    {
      props: ({ open }: { open?: boolean }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': { ...closedMixin(theme) },
      },
    },
  ],
}));
